import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./video-carousel.${locale}.json`));
